import { Tag } from 'antd'
import { BrowseField } from './BrowseField'
import {
  DimensionMultiBrowsePanel,
  type FolderDimensionOption,
} from './DimensionMultiBrowsePanel'

type Props = {
  value?: number[]
  onChange?: (ids: number[]) => void
  dimensions: FolderDimensionOption[]
  placeholder?: string
  disabled?: boolean
  className?: string
  trigger?: 'hover' | 'click'
}

function dimensionLabel(dim: FolderDimensionOption): string {
  return dim.is_manual ? '系统目录' : dim.name
}

export function KnowledgeDimensionMultiBrowseField({
  value,
  onChange,
  dimensions,
  placeholder = '请选择虚拟分类',
  disabled,
  className,
  trigger = 'click',
}: Props) {
  const ids = value || []
  const byId = new Map(dimensions.map((d) => [d.id, d]))

  return (
    <BrowseField
      placeholder={placeholder}
      hidePlaceholder
      disabled={disabled}
      className={className}
      trigger={trigger}
      panelClassName="app-browse-popover-panel--dimension"
      panel={
        <DimensionMultiBrowsePanel dimensions={dimensions} value={ids} onChange={onChange} />
      }
    >
      {ids.length ? (
        <span className="app-browse-field-tags">
          {ids.map((id) => {
            const dim = byId.get(id)
            return <Tag key={id}>{dim ? dimensionLabel(dim) : `#${id}`}</Tag>
          })}
        </span>
      ) : null}
    </BrowseField>
  )
}
